/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArticuloModelDto } from '../models/articulo-model-dto';
import { informacionAdicionalControllerActualizarArticulo } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-actualizar-articulo';
import { InformacionAdicionalControllerActualizarArticulo$Params } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-actualizar-articulo';
import { informacionAdicionalControllerCrearArticulo } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-crear-articulo';
import { InformacionAdicionalControllerCrearArticulo$Params } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-crear-articulo';
import { informacionAdicionalControllerEliminarArticulo } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-eliminar-articulo';
import { InformacionAdicionalControllerEliminarArticulo$Params } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-eliminar-articulo';
import { informacionAdicionalControllerObtencionArticulos } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-obtencion-articulos';
import { InformacionAdicionalControllerObtencionArticulos$Params } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-obtencion-articulos';
import { informacionAdicionalControllerObtenerArticulo } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-obtener-articulo';
import { InformacionAdicionalControllerObtenerArticulo$Params } from '../fn/doctor-informacion-adicional/informacion-adicional-controller-obtener-articulo';

@Injectable({ providedIn: 'root' })
export class DoctorInformacionAdicionalService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `informacionAdicionalControllerObtencionArticulos()` */
  static readonly InformacionAdicionalControllerObtencionArticulosPath = '/api/informacion-adicional/obtener-articulos';

  /**
   * Obtener articulos.
   *
   * Obtiene una lista de articulos
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informacionAdicionalControllerObtencionArticulos()` instead.
   *
   * This method doesn't expect any request body.
   */
  informacionAdicionalControllerObtencionArticulos$Response(params?: InformacionAdicionalControllerObtencionArticulos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArticuloModelDto>>> {
    return informacionAdicionalControllerObtencionArticulos(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener articulos.
   *
   * Obtiene una lista de articulos
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informacionAdicionalControllerObtencionArticulos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informacionAdicionalControllerObtencionArticulos(params?: InformacionAdicionalControllerObtencionArticulos$Params, context?: HttpContext): Observable<Array<ArticuloModelDto>> {
    return this.informacionAdicionalControllerObtencionArticulos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ArticuloModelDto>>): Array<ArticuloModelDto> => r.body)
    );
  }

  /** Path part for operation `informacionAdicionalControllerObtenerArticulo()` */
  static readonly InformacionAdicionalControllerObtenerArticuloPath = '/api/informacion-adicional/obtener-articulo/{uuidArticulo}';

  /**
   * Obtener artículo por UUID.
   *
   * Obtiene un artículo específico por su UUID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informacionAdicionalControllerObtenerArticulo()` instead.
   *
   * This method doesn't expect any request body.
   */
  informacionAdicionalControllerObtenerArticulo$Response(params: InformacionAdicionalControllerObtenerArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticuloModelDto>> {
    return informacionAdicionalControllerObtenerArticulo(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener artículo por UUID.
   *
   * Obtiene un artículo específico por su UUID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informacionAdicionalControllerObtenerArticulo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informacionAdicionalControllerObtenerArticulo(params: InformacionAdicionalControllerObtenerArticulo$Params, context?: HttpContext): Observable<ArticuloModelDto> {
    return this.informacionAdicionalControllerObtenerArticulo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ArticuloModelDto>): ArticuloModelDto => r.body)
    );
  }

  /** Path part for operation `informacionAdicionalControllerCrearArticulo()` */
  static readonly InformacionAdicionalControllerCrearArticuloPath = '/api/informacion-adicional/crear-articulo';

  /**
   * Creación de artículo.
   *
   * Crea un artículo
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informacionAdicionalControllerCrearArticulo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informacionAdicionalControllerCrearArticulo$Response(params: InformacionAdicionalControllerCrearArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return informacionAdicionalControllerCrearArticulo(this.http, this.rootUrl, params, context);
  }

  /**
   * Creación de artículo.
   *
   * Crea un artículo
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informacionAdicionalControllerCrearArticulo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informacionAdicionalControllerCrearArticulo(params: InformacionAdicionalControllerCrearArticulo$Params, context?: HttpContext): Observable<void> {
    return this.informacionAdicionalControllerCrearArticulo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `informacionAdicionalControllerActualizarArticulo()` */
  static readonly InformacionAdicionalControllerActualizarArticuloPath = '/api/informacion-adicional/actualizar-articulo/{uuidArticulo}';

  /**
   * Actualización del artículo.
   *
   * Actualiza un artículo existente
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informacionAdicionalControllerActualizarArticulo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informacionAdicionalControllerActualizarArticulo$Response(params: InformacionAdicionalControllerActualizarArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return informacionAdicionalControllerActualizarArticulo(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualización del artículo.
   *
   * Actualiza un artículo existente
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informacionAdicionalControllerActualizarArticulo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  informacionAdicionalControllerActualizarArticulo(params: InformacionAdicionalControllerActualizarArticulo$Params, context?: HttpContext): Observable<void> {
    return this.informacionAdicionalControllerActualizarArticulo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `informacionAdicionalControllerEliminarArticulo()` */
  static readonly InformacionAdicionalControllerEliminarArticuloPath = '/api/informacion-adicional/eliminar-articulo/{uuidArticulo}';

  /**
   * Eliminar artículo.
   *
   * Elimina un artículo y sus relaciones con programas
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `informacionAdicionalControllerEliminarArticulo()` instead.
   *
   * This method doesn't expect any request body.
   */
  informacionAdicionalControllerEliminarArticulo$Response(params: InformacionAdicionalControllerEliminarArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return informacionAdicionalControllerEliminarArticulo(this.http, this.rootUrl, params, context);
  }

  /**
   * Eliminar artículo.
   *
   * Elimina un artículo y sus relaciones con programas
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `informacionAdicionalControllerEliminarArticulo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  informacionAdicionalControllerEliminarArticulo(params: InformacionAdicionalControllerEliminarArticulo$Params, context?: HttpContext): Observable<void> {
    return this.informacionAdicionalControllerEliminarArticulo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
